import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { WhyTipsFail } from './components/WhyTipsFail';
import { Mapa3DSection } from './components/Mapa3DSection';
import { CryingObjection } from './components/CryingObjection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { ExpectationsSection } from './components/ExpectationsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#0c1425] text-cream overflow-x-hidden selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <WhyTipsFail data-id="element-3" />
      <Mapa3DSection data-id="element-4" />
      <CryingObjection data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <WhoItsFor data-id="element-7" />
      <ExpectationsSection data-id="element-8" />
      <CTASection data-id="element-9" />
      <Footer data-id="element-10" />
    </main>;
}